// Endpoints which will not build a user object when accessed
// 'build a user object' may include 'perform token refresh' or 'perform Google OAuth login'
// depending on stored credentials
// Checks are normalized to lower case during execution

export default [
  '/oauth/login'
];
